module.exports = __webpack_public_path__ + "static/media/25UNHCR2.7ada2695.jpg";